import type { Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";

export const getDotGridBackground = (theme: Theme): SystemStyleObject<Theme> => ({
  backgroundColor: theme.palette.surface.neutral.supershy,
  backgroundImage: `radial-gradient(circle, ${theme.palette.surface.neutral.moderate} 2px, transparent 2px)`,
  backgroundSize: "40px 40px",
});
